module.exports = __webpack_public_path__ + "img/logostiendas.5183cad7.png";